module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/LadiesinLavender-448x252.7ba5386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/LadiesinLavender-448x252.jpg
// module id = bxJH
// module chunks = 0